import { gql } from 'apollo-angular';

/**
 * Queries handling Nexus-related objects.
 */
export class NexusQueries {
	public static ALL_FUNCTIONAL_GROUPS_QUERY = gql`
		query nexusAllFunctionalGroups {
			nexusAllFunctionalGroups {
				description
				name
				uid
			}
		}
	`;

	public static NEXUS_USER_QUERY = gql`
		query nexusUser($username: String!) {
			nexusUser(username: $username) {
				responseMessages
				returnValue
				success
			}
		}
	`;

	public static NEXUS_ALL_USERS_QUERY = gql`
		query nexusAllUsers {
			nexusAllUsers {
				functionalGroups {
					functionalGroupName
					functionalGroupUid
					isDefault
				}
				groupUids
				isAdministrator
				isSuperUser
				name
				subjectUid
				username
				email
			}
		}
	`;
}
